import { DestroyRef, Directive, ElementRef, inject, NgZone } from '@angular/core';
import { InmCarousel } from './inm-carousel.component';

@Directive({
  selector: '[inmCarouselNext]',
  standalone: true,
  host: {
    class: 'inm-carousel__control inm-carousel__control--next',
    role: 'button',
  },
})
export class InmCarouselNext {
  constructor() {
    const carousel = inject(InmCarousel);
    const element = inject(ElementRef).nativeElement as HTMLElement;
    const destroyRef = inject(DestroyRef);
    const zone = inject(NgZone);
    const handler = (event: Event) => {
      event.preventDefault();
      zone.run(() => carousel.next());
    };

    zone.runOutsideAngular(() => {
      element.addEventListener('click', handler);
    });

    destroyRef.onDestroy(() => element.removeEventListener('click', handler));
  }
}
